import React from 'react';
import Play from 'src/app/icons/Monospaced/Play/Play';
import { PlayButtonContainer } from './PlayButtonIcon.styles';

const PlayButtonIcon = (): JSX.Element => (
  <PlayButtonContainer
    padding='spacing-2xl'
    justify='center'
    align='center'
    borderRadius='radius-circle'
  >
    <Play />
  </PlayButtonContainer>
);

export default PlayButtonIcon;
